import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LocalizationContext } from '../App';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';
import Grid from '@mui/material/Grid';
import { alpha, styled } from '@mui/material/styles';
import env from "react-dotenv";
import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import { ReactSession } from 'react-client-session';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import Alert from '@mui/material/Alert';


const LoupeActivityCompleted = props => {

    const navigate = useNavigate();
    const location = useLocation();

    const currentActivity = location.state?.activity;
    
    console.log(currentActivity.context);

    const goHome = () => {
        if(currentActivity.source == "code") {
            navigate('/', { replace : true });
        } else {
            navigate('/activities-here', { replace : true });
        }
    }

    const openFollowup = (code) => {
        navigate('/start/' + code, {replace : true });
    }

    return(

        <LocalizationContext.Consumer>

            { ({strings}) =>
                
                <div className="padding">  
                   
                    <Paper className="container padding" elevation={0} square>

                        <Typography variant="h5" className="mb-6" gutterBottom component="div">{strings.getString("texts.activity.completed.title")}</Typography>

                        <Typography className="text-start mb-4" variant="body1" gutterBottom component="div">
                            {strings.getString("texts.activity.completed.main")}
                        </Typography>

                        { currentActivity.context.hasFollowUp &&
                            <>                                
                                <Alert severity="info" className="mb-4">
                                    <Typography className="text-start mb-4" variant="body1" gutterBottom component="div">
                                        {strings.getString("texts.activity.context.followup")}    
                                    </Typography>
                                    <Button color="secondary" className="mb-4" onClick={() => openFollowup(currentActivity.context.followupActivity)}>{strings.getString("controls.buttons.activity.followup")}</Button>
                                </Alert>

                            </>
                        }

                        <Typography className="text-start mb-4" variant="body1" gutterBottom component="div">
                            {strings.getString("texts.activity.completed.confidential")}    
                        </Typography>


                        <Button onClick={goHome}>{strings.getString("controls.buttons.activity.end")}</Button>

                    </Paper>

           

            
                </div>  

            }

        </LocalizationContext.Consumer>
    
    
    
    );

}
export default LoupeActivityCompleted;